import { useState } from "react";
import { Form, Modal, Button } from "react-bootstrap";
import { createReferences } from "../../../http/referencesAPI";
import { createUsefulLinks } from "../../../http/usefulLinksAPI";

const AddUsefulLinkModal = ({ show, onHide }) => {
	const [title, setTitle] = useState("");
	const [link, setLink] = useState("");
	const [img, setImg] = useState([null]);

	const addUsefulLinks = () => {
		const formData = new FormData();
		formData.append("title", title);
		formData.append("link", link);
		formData.append("img", img);
		createUsefulLinks(formData).then(() => window.location.reload());
	};

	const selectFile = (e) => {
		setImg(e.target.files[0]);
	};

	return (
		<Modal
			show={show}
			onHide={onHide}
			className='add-news-modal border-primary'>
			<Modal.Header
				closeButton={onHide}
				className='bg-primary'
				closeVariant='white'>
				<Modal.Title className='text-white'>Adauga o referita</Modal.Title>
			</Modal.Header>
			<Modal.Body>
				<div className='d-flex flex-column justify-content-around'>
					<span className='text-primary  font-2 py-2 ps-1'>Denumire</span>
					<Form.Control
						aria-label='Title'
						placeholder='Denumire'
						value={title}
						onChange={(e) => setTitle(e.target.value)}
					/>
					<span className='text-primary  font-2 py-2 ps-1'>Lincul catre resurs</span>
					<Form.Control
						aria-label='Link'
						placeholder='Lincul catre resurs'
						value={link}
						onChange={(e) => setLink(e.target.value)}
					/>
					<span className='text-primary  font-2 py-2 ps-1'>Logo-ul</span>
					{/* <InputGroup className='mb-3'>
										<InputGroup.Text id='basic-addon'>Logo-ul</InputGroup.Text> */}
					<Form.Control
						type={"file"}
						onChange={selectFile}
						aria-label='PageTitle'
						aria-describedby='basic-addon'
					/>
				</div>
			</Modal.Body>
			<Modal.Footer>
				<Button
					variant='secondary'
					onClick={onHide}>
					Close
				</Button>
				<Button
					variant='primary'
					onClick={() => {
						onHide();
						addUsefulLinks();
					}}>
					Confirm
				</Button>
			</Modal.Footer>
		</Modal>
	);
};

export default AddUsefulLinkModal;
